import React from 'react';
import { Stack, Image, ImageFit, Text } from '@fluentui/react';
import URL from "../../Containers/MainController";

const CardDownApp = () => {

    return (
        <Stack style={styles.container} >
            <Text style={styles.lable}>Tải ứng dụng Cổng thông tin đất đai tỉnh Cà Mau để có trải nghiệm tốt hơn trên thiết bị di động.</Text>
            <Stack style={styles.card}>
                <a href={URL.DownLoadIOS}>
                    <Image
                        src={process.env.PUBLIC_URL + '/images/icons/iphone-app-download.png'}
                        imageFit={ImageFit.contain}
                        width={100}
                        height={40}
                    />
                </a>
                <Stack style={{ width: 30 }} />
                <a href={URL.DownLoadAndroid}>
                    <Image
                        src={process.env.PUBLIC_URL + '/images/icons/logo-google-play.png'}
                        imageFit={ImageFit.contain}
                        width={100}
                        height={40}
                    />
                </a>
            </Stack>
        </Stack>
    )
};



export default CardDownApp;

const styles = {
    container: {
        marginTop: 10,
        borderTop: '1px solid gray'
    },
    lable: {
        textAlign: 'center',
        color: 'gray',
        marginTop: 7
    },
    card: {
        flexDirection: 'row',
        marginTop: 10,
        justifyContent: 'center'
    }
};


